export default {
  modules: [],
  loaded: false
}
